import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LoHiMappable } from '../map/map.service';

export interface HoneyMapDrivers {
  drivers: HoneyMapDriver[];
}

export interface HoneyMapDriver extends LoHiMappable {
  phone: string;
  lastUpdated: string;
  currentCompany: string | null;
  currentCompanyJoinedAt: Date | null;
  isFiveF: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class HoneyMapService {
  constructor(private httpClient: HttpClient) {}

  public getMapData$(
    onlyFiveF: boolean | string | null,
    onlyHAL: boolean | string | null,
    onlyBoxers: boolean | string | null,
    lastUpdatedWithinHours: number,
  ): Observable<HoneyMapDriver[]> {
    if (onlyFiveF === 'All') {
      onlyFiveF = null;
    }
    if (onlyHAL === 'All') {
      onlyHAL = null;
    }
    if (onlyBoxers === 'All') {
      onlyBoxers = null;
    }
    return this.httpClient
      .post<HoneyMapDrivers>(`${environment.api}/v1/internal/honey_map/drivers`, {
        onlyFiveF,
        onlyHAL,
        onlyBoxers,
        lastUpdatedWithinHours,
      })
      .pipe(map((value) => value.drivers));
  }
}
